import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import { useGetFieldsCitiesQuery } from 'services/api/Meteorology/Fields/TrackingForecast/Register';

export default function useCities() {
  const { data, error } = useGetFieldsCitiesQuery();

  useHandleRequestErrors(error as unknown as ResponseError);

  return { cities: data };
}
